export default (app) => {

    // 1.element-plus btn 防抖
    app.directive('preventReClick', {
        mounted(el, binding) {
            el.addEventListener('click', () => {
                if (!el.disabled) {
                    el.disabled = true
                    setTimeout(() => {
                        el.disabled = false
                    }, binding.value || 1000)
                }
            })
        }
    })

    // 2.dom 点击事件防抖
    app.directive('domPreventReClick', {
        mounted(el, binding) {
            el.addEventListener('click', () => {
                if (!el.style.pointerEvents) {
                    el.style.pointerEvents = "none"
                    setTimeout(() => {
                        el.style.pointerEvents = ""
                    }, binding.value || 1000)
                }
            })
        }
    })
}